import { FunnelPlotOutlined } from "@ant-design/icons";
import { Select, Input, DatePicker } from "antd";
import dayjs from "dayjs";
import { Component } from "react";

import i18next from "i18next";
import localeTH from "antd/es/date-picker/locale/th_TH";
import localeEN from "antd/es/date-picker/locale/en_US";

const { RangePicker } = DatePicker;
const { Search } = Input;

export class MainSearch extends Component {

   getAntdLocale = () => {
    const currentLanguage = i18next.language;
    if (currentLanguage === "th" || currentLanguage === "lao") {
      return localeTH;
    }
    return localeEN;
  };
  render() {
    let {
      t,
      handleChange,
      handleSelectTypeSearch,
      handleDateRangeChange,
      startDate,
      endDate,
      typeSearch,
      dataType
    } = this.props;
    let dateFormat = "YYYY-MM-DD";
    // ตั้งค่า Locale ภายใน Render เพื่อให้เปลี่ยนตาม i18next
    const antdLocale = this.getAntdLocale();
    const currentLanguage = i18next.language;
    dayjs.locale(currentLanguage === "lao" ? "lo" : currentLanguage);
	
    return (
      <>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="form-group">
            <Select
              style={{
                width: "100%",
                boxShadow: "none",
                border: "none",
              }}
              placeholder={t("Type")}
              prefix={t("Type") + " : "}
              defaultValue={{ value: "deposit", label: t("deposit") }}
              value={dataType}
              onChange={(value) => handleChange("dataType", value)}
              options={[
                {
                  label: t("deposit"),
                  value: "deposit",
                },
                {
                  label: t("withdraw"),
                  value: "withdraw",
                },
              ]}
            />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="form-group">
            <Select
              style={{
                width: "100%",
                boxShadow: "none",
                border: "none",
              }}
              placeholder={t("Status")}
              prefix={t("Status") + " : "}
              defaultValue={{ value: "", label: t("all") }}
              onChange={(value) => handleChange("dataStatus", value)}
              options={[
                {
                  label: t("all"),
                  value: "",
                },
                {
                  label: t("success"),
                  value: "SUCCESS",
                },
                {
                  label: t("pending"),
                  value: "PENDING",
                },
                {
                  label: t("PROCESSING"),
                  value: "PROCESSING",
                },
                {
                  label: t("VERRIFY_FAILED"),
                  value: "VERRIFY_FAILED",
                },
                {
                  label: t("rejected"),
                  value: "REJECTED",
                },
                {
                  label: t("ONHOLD"),
                  value: "ONHOLD",
                },
              ]}
            />
          </div>
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12">
          <div className="form-group">
            <RangePicker
              prefix={
                <span style={{ color: "#636363ff", fontWeight: "600" }}>
                  {t("Date")}
                </span>
              }
              defaultValue={[
                dayjs(startDate, dateFormat),
                dayjs(endDate, dateFormat),
              ]}
              className="w-100"
              locale={antdLocale}
              onChange={handleDateRangeChange}
            />
          </div>
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12">
          <div className="form-group">
            <Search
              id="sm-100-percen"
              className="sm-100-percen"
              placeholder="Search..."
              onSearch={(value) => handleSelectTypeSearch("searchText", value)}
              onChange={(e) =>
                handleSelectTypeSearch("searchText", e.target.value)
              }
              enterButton
              addonBefore={
                <>
                  <Select
                    onChange={(value) =>
                      handleSelectTypeSearch("typeSearch", value)
                    }
                    options={[{ label: "REF UUID", value: "refUuid" }]}
                    defaultValue={typeSearch}
                    prefix={<FunnelPlotOutlined />}
                    placeholder={t("filters")}
                  />
                </>
              }
              style={{
                width: "100%",
                boxShadow: "none",
                border: "none",
              }}
            />
          </div>
        </div>
      </>
    );
  }
}
